import { Injectable } from '@angular/core';

declare let alertify: any;

@Injectable({
  providedIn: 'root'
})
export class AlertifyService {

  constructor() { }

  confirm(message: string, okCallback: () => any){
    alertify.confirm(message, function(e) {
      if (e) {
        okCallback();
      }
    });
  }

  success(message: string, delay: number = 5) {
    alertify.success(message, delay);
  }

  error(message: string, delay: number = 5) {
    alertify.error(message, delay);
  }

  warning(message: string, delay: number = 5) {
    alertify.warning(message, delay);
  }

  message(message: string, delay: number = 5) {
    alertify.message(message, delay);
  }
}